export const HIDE_AFTER_MS = 1000;
const FADE_MS = 200;
const MIN_THUMB = 24;

export interface AxisMetrics {
  position: number;
  content: number;
  viewport: number;
}

export interface ThumbGeometry {
  size: number;
  offset: number;
}

export function thumbGeometry(m: AxisMetrics, track: number): ThumbGeometry | null {
  const range = m.content - m.viewport;
  if (range < 1 || track <= 0) return null;
  const size = Math.min(track, Math.max(MIN_THUMB, (track * m.viewport) / m.content));
  const offset = (track - size) * Math.min(1, Math.max(0, m.position / range));
  return { size, offset };
}

export function scrollPerThumbPx(m: AxisMetrics, track: number): number {
  const g = thumbGeometry(m, track);
  return g && track > g.size ? (m.content - m.viewport) / (track - g.size) : 0;
}

export function fadeMs(reducedMotion: boolean): number {
  return reducedMotion ? 0 : FADE_MS;
}

export interface Visibility {
  poke(): void;
  hold(on: boolean): void;
  dispose(): void;
}

// Hidden at rest; a poke shows it until HIDE_AFTER_MS of quiet; a hold keeps it up.
export function createVisibility(onChange: (visible: boolean) => void): Visibility {
  let visible = false;
  let held = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const set = (v: boolean) => {
    if (v === visible) return;
    visible = v;
    onChange(v);
  };
  const arm = () => {
    clearTimeout(timer);
    if (!held) timer = setTimeout(() => set(false), HIDE_AFTER_MS);
  };
  return {
    poke() {
      set(true);
      arm();
    },
    hold(on) {
      held = on;
      if (on) set(true);
      arm();
    },
    dispose() {
      clearTimeout(timer);
    },
  };
}
